<template>
    <!-- <frameset rows="88,*" cols="*" frameborder="no" border="0" framespacing="0">
  <frame src="/top" name="topFrame" scrolling="No" noresize="noresize" id="topFrame" title="topFrame" />
  <frameset cols="187,*" frameborder="no" border="0" framespacing="0">
      <frame src="/left" name="leftFrame" scrolling="auto" noresize="noresize" id="leftFrame" title="leftFrame" />
      <frame src="/desktop" name="rightFrame" id="rightFrame" title="rightFrame" />
    </frameset>
</frameset> -->
<div>
  <!-- <div v-show="showActivity" style="position: fixed; width:100%; height:100%; z-index:999; background:rgb(51, 51, 51); opacity: 0.6; 
    top: 0; left: 0;display: block;" @click="close();"/>
  <div class="tip" style="z-index:1000;display: block;width:500px;min-height:auto;max-height: 700px;" v-show="showActivity">
      <div class="tiptop"><span>618年中活动</span><a @click="close();"></a></div>
      <ul class="forminfo" style="margin-top:10px;">
          <li>
              <div id="activity618" style="width: 460px; height: 550px;"></div> -->
              <!-- <img src="../assets/images/618activity.jpg" style="width: 460px; height: 550px;"> -->
          <!-- </li>
      </ul>
  </div> -->
  <template v-if="flag">
    <div v-show="showActivity" style="position: fixed; width:100%; height:100%; z-index:999; background:rgb(51, 51, 51); opacity: 0.6; 
      top: 0; left: 0;display: block;" @click="close();"/>
    <div class="tip" style="z-index:1000;display: block;width:500px;min-height:auto;max-height: 700px;" v-show="showActivity">
        <div class="tiptop"><span>{{systemActivity.activityName}}</span><a @click="close();"></a></div>
        <ul class="forminfo" style="margin-top:10px;">
            <li>
                <img :src="url" style="width: 460px; height: 550px;">
            </li>
        </ul>
    </div>
  </template>
  <v-top></v-top>
  <frameset cols="187,*" style="min-height:800px;" frameborder="no" border="0" framespacing="0">
      <frame src="/left"  name="leftFrame" scrolling="auto" noresize="noresize" id="leftFrame" title="leftFrame" />
      <frame :src="rightUrl" name="rightFrame" id="rightFrame" title="rightFrame" />
    </frameset>
</div>
</template>
<script>
import top from '@/components/top.vue'

export default {
  data(){
        return{
            rightUrl:'desktop',
            showActivity: false,
            url: '',
            systemActivity: {},
            flag: false,
        }
    },
  components: {
    'v-top': top,
  },
  mounted(){
    let mobileString = localStorage.getItem("mobileString");
    if(null != mobileString && mobileString != ''){
      this.rightUrl = "smssend?mobile=" + mobileString;
      localStorage.removeItem("mobileString");
      localStorage.removeItem("orgId");
      localStorage.removeItem("loginId");
      localStorage.removeItem("memberIdstr");
    }
  },
  methods:{
    close() {
      this.showActivity = false;
    },
    showsystemactivity() {
      var that = this;
      this.$ajax({
          method: 'post',
          url: this.GLOBAL.serverSrc + '/main/getsystemactivity.json',
          data: {},
          headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              'token' : this.GLOBAL.token
          }
      }).then(function(res) {
        //console.log('showsystemactivity result:' + JSON.stringify(res.data));
        if('0000000' == res.data.code)
        {
          that.systemActivity = res.data.systemActivity;
          that.flag = res.data.flag;
          if(res.data.flag)
          {
            // that.url = res.data.frbd.dbyte;
            //var bytes = new Uint8Array(res.data.frbd.dbyte);
            //var blob = new Blob([bytes], { type: "image/jpg" });
            //var url1 = URL.createObjectURL(blob);
            var url1 = res.data.imgPath;
            if(url1.indexOf("D:\\share\\upload")!=-1)
            {
              //console.log('包含')
              //console.log('https://img.2office.cn/' + url1.substring(16));
              url1 = 'https://img.2office.cn/' + url1.substring(16);
            }
            that.url = url1;
            // that.url = that.readimg(res.data.frbd.dbyte);
            that.showActivity = true;
          }
          else
          {
            that.showActivity = false;
          }
        }
        else
        {
          that.$alert(res.data.msg);
        }
      })
    }
  },
  //显示图片流
  readimg() {
    var bytes = new Uint8Array(this.url);
    var blob = new Blob([bytes], { type: "image/jpg" });
    var url = URL.createObjectURL(blob);
    return url;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main.vue